import React, { Component } from 'react'

export default class ContentAreaDashboard extends Component {
  render() {
    return (
      <div className="content-area-dashboard">
        {this.props.children}
      </div>
    )
  }
}